export default {
  address: {
    id: 'address_book_rules_address_step',
    defaultMessage: 'Addresses',
  },
  activities: {
    id: 'address_book_rules_activities_step',
    defaultMessage: 'Activities',
  },
  markets: {
    id: 'address_book_rules_markets_step',
    defaultMessage: 'Markets',
  },
  categories: {
    id: 'address_book_rules_categories_step',
    defaultMessage: 'Categories',
  },
  productReturn: {
    id: 'address_book_rules_activity_product_return',
    defaultMessage: 'Product Return',
  },
  productRefund: {
    id: 'address_book_rules_activity_product_refund',
    defaultMessage: 'Product Refund',
  },
  productRepair: {
    id: 'address_book_rules_activity_product_repair',
    defaultMessage: 'Product Repair',
  },
  buyback: {
    id: 'address_book_rules_activity_buyback',
    defaultMessage: 'BuyBack',
  },
  backship: {
    id: 'address_book_rules_activity_backship',
    defaultMessage: 'BackShip',
  },
  allMarkets: {
    id: 'address_book_rules_all_markets_label',
    defaultMessage: 'All markets',
  },
  allCategories: {
    id: 'address_book_rules_all_categories_label',
    defaultMessage: 'All categories',
  },
  actions: {
    id: 'address_book_actions',
    defaultMessage: 'Open actions menu',
  },
  edit: {
    id: 'address_book_edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'address_book_delete',
    defaultMessage: 'Delete',
  },
}
